module.exports = __webpack_public_path__ + "static/media/star-runner-screenshot-4.9bf51546.jpg";